module.exports = __webpack_public_path__ + "img/PS3.f41b631e.png";